import type { Handler } from './handler';
import type { ApiFetchOfficialProfilesPort } from './ports/api-fetch-official-profiles.port';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';

export const fetchOfficialProfilesHandler: Handler<
  undefined,
  Ports,
  Result
> = async (
  ports = {
    apiFetchOfficialProfiles: resolveAdapter('apiFetchOfficialProfiles'),
  },
) => {
  const [profiles, fetchError] = await tryCatch(
    ports?.apiFetchOfficialProfiles.handle(),
  );

  if (fetchError) {
    console.error(
      '[fetchOfficialProfilesHandler] Erro ao buscar perfis oficiais:',
      fetchError,
    );

    return { profiles: [] };
  }

  return { profiles };
};

type Ports = {
  apiFetchOfficialProfiles: ApiFetchOfficialProfilesPort;
};

type Result = Promise<{ profiles: OfficialProfileListItem[] }>;
